"use client";

import { Grid } from "@mui/material";

import { StepButtonProps } from "@/types/button";

export default function StepButtonWrapper(props: StepButtonProps) {
  return (
    <Grid
      container
      justifyContent={props.containerJustifyContent ?? "flex-end"}
    >
      {props.button && (
        <Grid
          display="flex"
          justifyContent={props.itemJustifyContent ?? "flex-end !important"}
          size={props.gridSize}
        >
          {props.button}
        </Grid>
      )}
    </Grid>
  );
}
